export const jenis_kelamin = {
  1: "Laki laki",
  2: "Perempuan",
};

export const sts_hubungan = {
  1: "Kepala Keluarga",
  2: "Istri/Suami",
  3: "Anak",
  4: "Lainnya",
};

// export const sts_hubanak_ibu = {
//     "1": "Ibu Kandung",
//     "2": "Ibu Angkat",
//     "3": "Ibu Tiri",
//     "4": "Lainnya"
// }

export const sts_akta = {
  1: "Ya",
  2: "Tidak",
};

export const sts_kawin = {
  1: "Belum Kawin",
  2: "Kawin",
  3: "Cerai Hidup",
  4: "Cerai Mati",
};

export const jns_pendidikan = {
  1: "Tidak/Belum Sekolah",
  2: "Tidak Tamat SD/Sederajat",
  3: "Masih SD/Sederajat",
  4: "Tamat SD/Sederajat",
  5: "Tidak Tamat SMP/Sederajat",
  6: "Masih SMP/Sederajat",
  7: "Tamat SMP/Sederajat",
  8: "Tidak Tamat SMA/Sederajat",
  9: "Masih SMA/Sederajat",
  10: "Tamat SMA/Sederajat",
  11: "Masih PT/Akademi",
  12: "Tamat PT/Akademi",
  13: "PAUD",
};

export const jns_asuransi = {
  1: "BPJS-PBI/Jamkesmas/Jamkesda",
  2: "BPJS-Non PBI",
  3: "Swasta",
  4: "Tidak Memiliki",
};

export const id_agama = {
  1: "Islam",
  2: "Kristen",
  3: "Katolik",
  4: "Hindu",
  5: "Budha",
  6: "Konghucu",
  7: "Penghayat Kepercayaan",
};

export const id_pekerjaan = {
  1: "Tidak/Belum Bekerja",
  2: "Petani",
  3: "Nelayan",
  4: "Pedagang",
  5: "Pejabat Negara/Kepala Wilayah",
  6: "PNS/TNI/POLRI",
  7: "Swasta Sektor Pertanian",
  8: "Swasta Sektor Industri",
  9: "Swasta Sektor Jasa",
  10: "Pensiunan",
  11: "Pekerja Lepas",
};

export const sts_pekerjaan = {
  1: "Berusaha Sendiri",
  2: "Berusaha dibantu Buruh Tidak Tetap/Buruh Tidak Dibayar",
  3: "Berusaha dibantu Buruh Tetap/Buruh Dibayar",
  4: "Buruh/Karyawan/Pegawai",
  5: "Pekerja Bebas",
  6: "Pekerja Keluarga/Tidak Dibayar",
};

export const keberadaan = {
  1: "Di Dalam Rumah",
  2: "Di Luar Rumah",
  3: "Di Luar Negeri",
};

export const mak = {
  1: "Menikah",
  2: "Meninggal Dunia",
  3: "Anggota Baru",
  null: "Kosongkan Pilihan",
};

export const disabilitas = {
  1: "Fisik",
  2: "Sensorik",
  3: "Mental",
  4: "Intelektual",
  5: "Tidak",
};

export const kemampuan = {
  1: "Tidak Dapat Mengurus Diri Sendiri",
  2: "Banyak Mengalami Kesulitan",
  3: "Sedikit Mengalami Kesulitan",
  4: "Tidak Mengalami Kesulitan",
  null: "Kosongkan Pilihan",
};

export const bekerja_luar_negeri = {
  1: "Pernah",
  2: "Sedang ",
  3: "Akan (Dalam 3 tahun mendatang)",
  4: "Tidak",
};

export default {
  jenis_kelamin,
  sts_hubungan,
  // sts_hubanak_ibu,
  disabilitas,
  kemampuan,
  sts_akta,
  sts_kawin,
  jns_pendidikan,
  jns_asuransi,
  id_agama,
  id_pekerjaan,
  sts_pekerjaan,
  keberadaan,
  mak,
  bekerja_luar_negeri,
};
